import Products from '../components/Products'
//file renders products component
const Productspage = () => {
    return (
        <div>
            <Products />
        </div>
    )
}

export default Productspage
